<template>
  <div class="log-con">
    <LoginHeader />
    <ul class="add-log-wrap">
      <li>
        <FormLogin
          v-model:login-form="loginForm"
          v-model:error-login="errorLogin"
          type-login="CUSTOMER"
          domain="SELF_SERVICE"
          @handle-login="handleLogin"
        />
      </li>
      <li>
        <button type="button" class="primary-btn l-btn" @click="handleLogin">
          <span>{{ t('button_confirm') }}</span>
        </button>
      </li>
    </ul>
    <div class="or">
      <span>{{ t('or') }}</span>
    </div>

    <RouterLink to="/app/login" class="gray-btn l-btn">
      <span>{{ t('ss_login_as_host') }}</span>
    </RouterLink>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import FormLogin from '@/components/domains/chat/common/FormLogin.vue';
import LoginHeader from '@/components/domains/mobile/log/LoginHeader.vue';
import { useLogin } from '@/composables/shared/useLogin';

const { t } = useI18n();

const { loginForm, errorLogin, handleLogin } = useLogin();
</script>
<style scoped lang="scss">
.log-con {
  padding: $app-padding;
  .add-log-wrap {
    li {
      margin-bottom: $size-s;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .or {
    position: relative;
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      background: $color-gray-30;
      top: 50%;
      transform: translateY(-50%);
    }
    span {
      position: relative;
      background: #fff;
      z-index: 1;
      display: inline-block;
      padding: 1rem 0.5rem;
      color: $color-gray-80;
      font-size: $font-size-xxs;
    }
  }
  .gray-btn {
    text-decoration: none;
    span {
      color: $color-gray-900;
    }
  }
}
</style>
